/** @jsx jsx */
import { css, jsx } from "@emotion/core";

const Wrapper = ({ children }) => (
  <div css={styles} className="wrapper">
    {children}
  </div>
);

const styles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export default Wrapper;
